<template>
  <b-modal
    id="sms-inventory"
    size="xl"
    centered
    hide-backdrop
    hide-footer
    content-class="shadow sms-modal"
    :title="selectedFacility.facility_name"
  >
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead>
          <tr>
            <th style="width: 10%;"></th>
            <th v-for="month in months" :key="month">{{ month }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            <td v-for="month in months" :key="'allocation-' + month">
              {{ selectedFacility.slots?.[month]?.length > 0
                ? selectedFacility.slots[month][0].metadata.allocation
                : 0 }}
            </td>
          </tr>
          <tr>
            <td>Spent</td>
            <td v-for="month in months" :key="'spent-' + month">
              {{ selectedFacility.slots?.[month]?.length > 0
                ? selectedFacility.slots[month][0].metadata.consumed
                : 0 }}
            </td>
          </tr>
          <tr>
            <td>Remain</td>
            <td v-for="month in months" :key="'remain-' + month">
              {{ selectedFacility.slots?.[month]?.length > 0
                ? selectedFacility.slots[month][0].metadata.remaining
                : 0 }}
            </td>
          </tr>
          <tr>
            <td>New Allocation</td>
            <td v-for="month in months" class="new-allocation-cell" :key="'new-allocation-' + month">
              <b-form-input
                v-model="newAllocations[month]"
                type="text"
                inputmode="numeric"
                pattern="\d*"
                class="text-center"
                min="0"
                :aria-label="'New allocation for ' + month"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center mt-3 py-4">
      <b-button variant="primary" @click="submit">Confirm</b-button>
    </div>
  </b-modal>
</template>

<script>
import Store from "@/services/store";
import { generateMonthsColumns } from '../../../checkin-facility/utils/helpers';

export default {
  props: {
    selectedFacility: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      months: [],
      newAllocations: {},
    };
  },
  async mounted() {
    this.months = generateMonthsColumns(0, 12);
    this.newAllocations = this.months.reduce((acc, month) => {
      acc[month] = 0;
      return acc;
    }, {});
  },
  methods: {
    async submit() {
      const payload = {
        facility_id: this.selectedFacility.id,
        slots: this.newAllocations,
      };

      try {
        await this.$lionheart.post('/v2/facility/sms/admin/allocate-sms-slots', payload);

        this.$bvToast.toast('SMS slots allocated successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });

        this.newAllocations = this.months.reduce((acc, month) => {
          acc[month] = 0;
          return acc;
        }, {});
        this.$emit('refreshFacilities');
        this.$bvModal.hide('sms-inventory');
      } catch (error) {
        Store.commit("checkin-site/loading", false);
        let errorMessage = 'Error allocating SMS slots.';

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }

        // Error toast notification
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      }
    },
  },
};
</script>

<style scoped>

.sms-modal {
  max-width: 90vw;
  width: 90%;
  max-height: 80vh;
  margin: 0 auto;
  padding: 0;
  overflow-y: auto;
}

@media (min-width: 1200px) {
  .sms-modal {
    max-width: 75%;
    max-height: 75%;
  }
}

@media (max-width: 768px) {
  .sms-modal {
    max-width: 95%;
    max-height: 90%;
  }
}

@media (max-width: 576px) {
  .sms-modal {
    max-width: 100%;
    max-height: 100%;
  }
}

.table-responsive {
  overflow-x: auto;
}

</style>